import { AppState } from '../rootReducer';

export const getCheckPhoneExistStatus = (state: AppState) =>
  state.loginReducer.status;

export const getCheckPhoneExistMessage = (state: AppState) =>
  state.loginReducer.message;

export const getToken = (state: AppState) => state.loginReducer.token;
export const getAccessToken = (state: AppState) => state.loginReducer.accessToken;

export const getCheckValidatePhoneCodeValid = (state: AppState) =>
  state.loginReducer.isValid;

export const getLoginStatus = (state: AppState) =>
  state.loginReducer.isLoggedIn;

export const getCanForgot = (state: AppState) =>
  state.loginReducer.canForgotPassword;

export const getPhoneNumber = (state: AppState) => state.loginReducer.phone;
export const getCustomerCode = (state: AppState) => state.loginReducer.customerCode;
export const getLoginMessage = (state: AppState) => state.loginReducer.message;
export const getLoginErrorCode = (state: AppState) =>
  state.loginReducer.errorCode;
export const getIsFirstLogin = (state: AppState) =>
  state.loginReducer.profile.login_first;
export const getUserProfile = (state: AppState) =>
  state.loginReducer.profile;
export const getCurrentPassword = (state: AppState) =>
  state.loginReducer.password;
export const getLocation = (state: AppState) =>
  state.loginReducer.location;
export const getBizErrors = (state: AppState) =>
  state.loginReducer.bizErrors;
export const getIsNewAccount = (state: AppState) =>
  state.loginReducer.isNewAccount;
